import { getCsrfValue } from "../../api/ApiHelper";

import { resolveApiUrl } from "../../utils/url/urlResolver";

const apiUrl = resolveApiUrl("/registered/user/resend/mail");

export const resendUserEmail = async (email: string): Promise<Response> => {
  const response = await fetch(`${apiUrl}/${email}`, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    headers: {
      CSRFToken: getCsrfValue(),
    },
  });

  if (!response.ok) {
    throw new Error("Error status: " + response.status + ", please try again");
  }

  return response;
};
